import type { SxProps, Theme } from '@mui/material';

export const styles = {
    card: (theme: Theme): SxProps<Theme> => ({
        p: { xs: 1.5, md: 2 },
        borderRadius: '8px',
        backgroundColor: theme.palette.background.paper,
        boxShadow: theme.shadows[1],
        mb: 2,
    }),
    title: { fontSize: '16px', fontWeight: 600, mb: 1.5 } as SxProps<Theme>,
    grid: {
        display: 'grid',
        gridTemplateColumns: { xs: '1fr', sm: 'repeat(2, 1fr)', md: 'repeat(4, 1fr)' },
        gap: 2,
        alignItems: 'flex-start',
    } as SxProps<Theme>,
    full: { gridColumn: { sm: '1 / -1' } } as SxProps<Theme>,
    half: { gridColumn: { sm: 'span 2' } } as SxProps<Theme>,
    vinField: {
        gridColumn: { sm: '1 / -1' },
        // The theme floats helper text with position:absolute (bottom:-20), so it
        // doesn't add to the field height and overlaps the row below. Put this
        // field's helper back in flow so the grid gap separates the rows.
        '& .MuiFormHelperText-root': {
            position: 'static',
            mt: 0.5,
        },
    } as SxProps<Theme>,
    decoded: (theme: Theme): SxProps<Theme> => ({
        gridColumn: { sm: '1 / -1' },
        p: 1.5,
        borderRadius: '6px',
        backgroundColor: theme.palette.green[30],
        color: theme.palette.green[600],
        fontSize: '13px',
    }),
    estimateBox: (theme: Theme): SxProps<Theme> => ({
        gridColumn: { sm: '1 / -1' },
        p: 1.5,
        borderRadius: '6px',
        backgroundColor: theme.palette.blue[30],
        fontSize: '13px',
    }),
    estimateLine: { ml: 2, fontSize: '13px' } as SxProps<Theme>,
    actions: {
        gridColumn: { sm: '1 / -1' },
        display: 'flex',
        gap: 1,
        mt: 1,
        flexWrap: 'wrap',
    } as SxProps<Theme>,
};
